export interface IProject {
    activeName: string,
    province?: string,
    city?: string,
}

export interface IProjectAction {
    type: string,
    payload?: IProject
}
const userNameLocal = localStorage.getItem("userName");
const activeProject = localStorage.getItem(`${userNameLocal}_active_project`);
const activeProvince = localStorage.getItem(`${userNameLocal}_active_Province`);
const activeCity = localStorage.getItem(`${userNameLocal}_active_City`);
const projectDefault: IProject = {
    activeName: activeProject ? activeProject : "",
    province: activeProvince ? activeProvince : '',
    city: activeCity ? activeCity : '',
}

function projectReducer(state: IProject = projectDefault, action: IProjectAction): IProject {

    switch (action.type) {
        case 'SIGN_IN':
            const username = localStorage.getItem("userName");
            const project = localStorage.getItem(`${username}_active_project`);
            const province = localStorage.getItem(`${userNameLocal}_active_Province`);
            const city = localStorage.getItem(`${userNameLocal}_active_City`);
            return {
                activeName: project ? project : "",
                province: province ? province : '',
                city: city ? city : '',
            }
        case "UPDATE_PROJECT":
            return Object.assign({}, state, action.payload);
        case "CLEAR_PROJECT":
            return { activeName: "" };
        case 'SIGN_OUT':
            return { activeName: "" };
        default:
            return state;

    }
}

export default projectReducer;